const HRSelfAppraisalPrinc = () => {
	return `mutation hrSelfAppraisal(
		$appraisee_id: String
		$principles: [AppraisalInput]
	) {
		hrSelfAppraisal(
			appraisee_id: $appraisee_id
			principles: $principles
		)
	}`;
}

export default HRSelfAppraisalPrinc;
